/**
 * Labstep
 *
 * @module components/Filter/Search
 * @desc Search Bar Filter
 */

import { useParamsContext } from 'labstep-web/contexts/params/hook';
import { Flex } from 'labstep-web/core/Flex';
import { SearchBar } from 'labstep-web/core/SearchBar';
import { SearchBarToggle } from 'labstep-web/core/SearchBar/Toggle';
import type { ParamsHOCChildrenProps } from 'labstep-web/hoc/Params/types';
import { Log } from 'labstep-web/models/log.model';
import type React from 'react';
import type { IFilterSearchProps } from './types';

export const onSearchChange = (
  value: string,
  setParams: ParamsHOCChildrenProps['setParams'],
  searchKey: string,
) => {
  const param = value === '' ? undefined : value;
  setParams({ [searchKey]: param });
};

export const FilterSearch: React.FC<IFilterSearchProps> = ({
  entityName,
  searchKey = 'search_query',
  searchBarProps,
  hideSearch = false,
}) => {
  const { setParams, searchParams, clearAll } = useParamsContext();
  const props = {
    defaultValue: searchParams[searchKey] as string,
    onChange: (value: string) =>
      onSearchChange(value, setParams, searchKey),
  };

  if (hideSearch || entityName === Log.entityName) {
    if (searchBarProps?.label) {
      return (
        <Flex grow hAlignContent="right">
          <div>{searchBarProps.label}</div>
        </Flex>
      );
    }
    return null;
  }

  return searchBarProps && 'viewComponent' in searchBarProps ? (
    <SearchBarToggle
      onClose={clearAll}
      {...props}
      {...searchBarProps}
    />
  ) : (
    <SearchBar {...props} {...searchBarProps} />
  );
};
